// extracted by mini-css-extract-plugin
export default {"wrap":"StagesScreen_wrap__l7EdD","stages_icons_wrap":"StagesScreen_stages_icons_wrap__PM6lN"};